import { Loader2 } from "lucide-react";

import { Button } from "../../../components/ui/button";
import { useSaveStatusStore } from "../../../stores/saveStatusStore";
import { useReadOnly } from "../../lock/ReadOnlyContext";

type FooterActionProperties = {
  onSave?: () => void;
  onExit?: () => void;
  /**
   * When another analyst holds the deal lock, hide Save entirely — there is
   * nothing this user can save, so a disabled button would only add noise.
   */
  hideSave?: boolean;
  /**
   * True while Save is re-checking the force-exit status at click time.
   * Disables the button and swaps the label for a spinner so a second click
   * can't race the in-flight check.
   */
  isCheckingForceExit?: boolean;
};

function FooterAction({ onSave, onExit, hideSave = false, isCheckingForceExit = false }: FooterActionProperties) {
  const readOnly = useReadOnly();
  const isSaving = useSaveStatusStore((state) => state.isSaving);

  return (
    <footer className="border-border bg-card flex shrink-0 items-center justify-end gap-2 border-t px-4 py-2 lg:px-6 lg:py-2.5">
      <Button variant="outline" size="sm" onClick={onExit}>
        Exit
      </Button>
      {!hideSave && (
        <Button size="sm" onClick={onSave} disabled={readOnly || isSaving || isCheckingForceExit}>
          {isCheckingForceExit && <Loader2 className="size-4 animate-spin" />}
          Save
        </Button>
      )}
    </footer>
  );
}

export default FooterAction;
